import { Layout } from '@/views/import_profile';

export default {
    path: '/import',
    component: Layout,
    children: [
        { path: 'grid', component: () => import('@/views/import_profile/ImportGrid.vue') },
    ]
};
